import { create } from 'zustand';

import { VOTE_PAGE_SIZE } from './votes';

interface VotesQueryState {
  search: string;
  page: number;
  pageSize: number;
  setSearch: (search: string) => void;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  reset: () => void;
}

const defaults: Pick<VotesQueryState, 'search' | 'page' | 'pageSize'> = {
  search: '',
  page: 1,
  pageSize: VOTE_PAGE_SIZE,
};

export const useVotesStore = create<VotesQueryState>((set) => ({
  ...defaults,

  setSearch: (search) => set({ search, page: 1 }),
  setPage: (page) => set({ page }),
  setPageSize: (pageSize) => set({ pageSize, page: 1 }),

  reset: () => set(defaults),
}));
